module.exports = __webpack_public_path__ + "static/media/smart-home.b6da8a3c.svg";